/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-named-as-default */
import { MsalProvider } from "@azure/msal-react";
import { CacheProvider, EmotionCache } from "@emotion/react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { SnackbarProvider, SnackbarProviderProps } from "notistack";
import { HelmetProvider } from "react-helmet-async";
import { useSelector } from "react-redux";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { protectedRoutes } from "./routes/protected";
import { publicRoutes } from "./routes/public";
import { persistor } from "./store";
import { themes } from "./styles/mui/theme";
import { authConfig } from "./utils/azure-ad";
import createEmotionCache from "./utils/emotion-cache";
import { selectProfile, selectProfileRole } from "./store/profile/selector";
import { useEffect } from "react";
import { LayoutPrivateRoute, LayoutPublicRoute } from "./layout";
import { UseModalProvider } from "./shared/Hooks/use-modal/provider";
import ReactGA from "react-ga4";
import Keys from "./constants/Keys";

interface CustomAppProps {
  emotionCache?: EmotionCache;
}

const clientSideEmotionCache = createEmotionCache();
// unstable_ClassNameGenerator.configure((componentName) => componentName.replace('Mui', 'binus-'));
const snackbarConfig: SnackbarProviderProps = {
  anchorOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  autoHideDuration: 3000,
  style: {
    maxWidth: 300,
  },
};

function App({ emotionCache = clientSideEmotionCache }: CustomAppProps) {
  const profileRole = useSelector(selectProfileRole);
  const passport = useSelector(selectProfile);

  useEffect(() => {
    ReactGA.initialize(Keys.GAMeasurementID);
  }, []);

  return (
    <AllProvider emotionCache={emotionCache}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route>
            {publicRoutes.map((route) => (
              <Route
                path={route.path}
                element={
                  route.noLayout ? (
                    <route.component />
                  ) : (
                    <LayoutPublicRoute>
                      <route.component />
                    </LayoutPublicRoute>
                  )
                }
                key={route.key}
              />
            ))}
            {protectedRoutes.map((route) => (
              <Route
                path={route.path}
                element={
                  <LayoutPrivateRoute>
                    {(!route.access ||
                      profileRole?.access?.includes(route.access)) &&
                    passport &&
                    profileRole?.access ? (
                      <route.component />
                    ) : (
                      <Navigate to="/" />
                    )}
                  </LayoutPrivateRoute>
                }
                key={route.key}
              />
            ))}
          </Route>
        </Routes>
      </BrowserRouter>
    </AllProvider>
  );
}

export function AllProvider({
  children,
  emotionCache,
}: {
  children: JSX.Element[];
  emotionCache: EmotionCache;
}) {
  return (
    <MsalProvider instance={authConfig}>
      <CacheProvider value={emotionCache}>
        <HelmetProvider>
          <PersistGate loading={null} persistor={persistor}>
            <SnackbarProvider
              anchorOrigin={snackbarConfig.anchorOrigin}
              autoHideDuration={snackbarConfig.autoHideDuration}
              style={snackbarConfig.style}
            >
              <ThemeProvider theme={themes}>
                <UseModalProvider>{children}</UseModalProvider>
              </ThemeProvider>
            </SnackbarProvider>
          </PersistGate>
        </HelmetProvider>
      </CacheProvider>
    </MsalProvider>
  );
}

export default App;
